<template>
  <footer class="footer-custom">
    <!-- <div>
      <div class="row">
        <div class="col">
          <span>© {{copyrightYear}} Howuku.
          <a class="ml-2 text-muted" target="_blank" href="https://howuku.com/terms">Terms of Service</a>
          <a class="ml-2 text-muted" target="_blank" href="https://howuku.com/privacy">Privacy Policy</a>
          </span>
        </div>
        <div class="col ml-auto text-right">
          <a href="https://howuku.com/blog" class="ml-2 text-muted">Blog</a>
          <a href="https://twitter.com/howuku" class="ml-2 text-muted">Twitter</a>
        </div>
      </div>
    </div>-->
  </footer>
</template>

<script>
/* eslint-disable */
export default {
  data: function () {
    return {
      copyrightYear: new Date().getFullYear(),
    }
  },
}
</script>
<style>
/* .footer-custom {
  width: calc(100% - 60px);
  bottom: 0;
  position: static;
  font-size: 16px;
  padding: 20px 20px;
  margin-left: 60px;
} */
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue